 const defaultSettings = {
  //测试环境
  // loginPath: "http://api.insafety.online:28883/#/login",
  //生产环境
  // loginPath: "https://content.guansafety.com/#/login",
  //预生产环境
  // loginPath: "https://pre-content.guansafety.com:18883/#/login",

  title: "",
  /**
   * @type {boolean} true | false
   * @description Whether need tagsView
   */
  tagsView: false,

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: false,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: true,
};
module.exports = defaultSettings